import BaseSelector from "../../../Common/Component/Select/BaseSelector";

const BooleanSelector = ({
                             required = false,
                             defaultValue = BOOLEAN_SELECTOR[2],
                             title = "Ativo",
                             setValue = BOOLEAN_SELECTOR,
                             ...props
                         }) => {

    return <BaseSelector
        showCreateButton={false}
        defaultValue={defaultValue}
        title={title}
        required={required}
        label="label"
        setValue={setValue}
        items={BOOLEAN_SELECTOR}
        {...props}
    />
}
export default BooleanSelector;

export  const BOOLEAN_SELECTOR = [
    {id: "true", label: "Ativo"},
    {id: "false", label: "Inátivo"},
    {id: "", label: "Todos"}
];
